'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jwtDecode = require('jwt-decode');

// Currently, CSR roles aren't supported for non-HIPAA retailers.
let UserRoles = /*#__PURE__*/function (UserRoles) {
  UserRoles["UNKNOWN"] = "unknown";
  UserRoles["CSR_HIPAA"] = "csrHipaa";
  UserRoles["CSR_ADMIN_HIPAA"] = "csrAdminHipaa";
  UserRoles["CUSTOMER"] = "customer";
  return UserRoles;
}({});
const getUserRole = (retailerMoniker, token) => {
  if (!retailerMoniker || !token) {
    return UserRoles.UNKNOWN;
  }
  const decodedToken = jwtDecode.jwtDecode(token);
  const {
    groups,
    return_hipaa_csr
  } = decodedToken;
  if (!groups || !return_hipaa_csr) {
    // If the token does not contain the groups or return_hipaa_csr fields, we assume a valid token means the user is a customer.
    return UserRoles.CUSTOMER;
  }
  const retailerRolePath = `/retailer/${retailerMoniker}/`;
  const hasCsrRole = groups.some(group => group === null || group === void 0 ? void 0 : group.startsWith(retailerRolePath));
  const hasCsrAdminRole = groups.includes(`${retailerRolePath}ADMIN`);
  const isCsrForHipaaRetailer = return_hipaa_csr === null || return_hipaa_csr === void 0 ? void 0 : return_hipaa_csr.includes(retailerMoniker);
  if (hasCsrAdminRole && isCsrForHipaaRetailer) {
    return UserRoles.CSR_ADMIN_HIPAA;
  }
  if (groups.length > 1 || return_hipaa_csr.length > 1) {
    // If not a CSR Admin, and the user has more than one group or retailer listed in return_hipaa_csr,
    // we assume the user is an unknown and possibly a security threat.
    return UserRoles.UNKNOWN;
  }
  if (hasCsrRole && isCsrForHipaaRetailer) {
    return UserRoles.CSR_HIPAA;
  }

  // Currently, CSR roles aren't supported for non-HIPAA retailers.

  return UserRoles.CUSTOMER;
};

exports.UserRoles = UserRoles;
exports.getUserRole = getUserRole;
